// Generated from accounting-backend/commercial/salesPresentation.json.
// To restore quarterly/yearly choices, edit visibleBillingCycles there, run
// `node scripts/commercial/export-definitions.js --write` from accounting-backend,
// then rebuild/deploy this frontend and ledgerloop-web. See the JSON's _comment.
import salesPresentation from '../config/salesPresentation.json';

export const billingCycles = Object.freeze({
    yearly: { label: 'Årsvis', period: 'år', months: 12 },
    quarterly: { label: 'Kvartalsvis', period: 'kvartal', months: 3 },
    monthly: { label: 'Månadsvis', period: 'månad', months: 1 },
});

// Used by CompanyPlanSelection and SubscriptionSection: show only configured
// intervals that have a published price. billingCycles above still describes all
// intervals for existing subscription summaries, renewal reviews and add-ons.
// This does not reject backend checkout requests for a hidden billing interval.
export const publishedBillingCycles = (plans, visibleCycles = salesPresentation.visibleBillingCycles) => visibleCycles.filter(cycle =>
    Object.hasOwn(billingCycles, cycle) &&
    plans.some(plan => plan.plan_name !== 'beta_free' && (plan.billing_prices || []).some(price => price.billingCycle === cycle)));
